import React, { useState, useContext, useEffect, useRef } from "react";
import "../../../../Users/homepage.css";
import "../../../../Users/pages/innercss.css";
import { Form, Link, redirect } from "react-router-dom";
import { useParams } from 'react-router-dom'
import { apiurl } from "../../../../../path";
import UserApplication from "../../../../Users/UserContext/UserContext";
import { Bank32, barely_black_bg_img, Cancel32, Email32, Location32, PhoneNumber32, submit } from "../../../../../public/LoginImages/importimages";


const VendorRegister = () => {
  let data = useContext(UserApplication)
  const { SetNotification, paymentdata, GetAuctionsList, TenderRegisterHash, TenderPayment, DownloadReciept, setpaymentdata } = data
  const [form, setform] = useState([])
  const [Auction, SetAuction] = useState([])
  const { Auction_ID, Auction_Name } = useParams()
  const [forminf, SetForminf] = useState({
    Bidder_CompanyName: "",
    Address: "",
    City: "",
    PinCode: "",
    GST_No: "",
    PAN_No: "",
    Mobile_No: "",
    Email: "",
    Tender_ID: "",
    Tender_Name: "",
    TenderFee: "",
    ErnestMoneyDeposit: "",
    GST: "",
    Account_Number: "",
    IFSC_CODE: "",
    BANK_NAME: "",
    Account_HolderName: "",
    BranchName: ""
  })
  console.log(forminf.IFSC_CODE);
  const [formErrors, setFormErrors] = useState({
    Bidder_CompanyName: "",
    Address: "",
    City: "",
    PinCode: "",
    GST_No: "",
    PAN_No: "",
    Mobile_No: "",
    Email: "",
    Tender_ID: "",
    Tender_Name: "",
    TenderFee: "",
    ErnestMoneyDeposit: "",
    GST: "",
    Account_Number: "",
    IFSC_CODE: "",
    BANK_NAME: "",
    Account_HolderName: "",
    BranchName: ""
  })

  const [recieptview, showrecieptview] = useState(true)
  const [isGSTValid, setIsGSTValid] = useState(null);
  const [isPANValid, setIsPANValid] = useState(null);
  const [accountnum, setaccountnum] = useState(null);

  const [isIfscValid, setIsIfscValid] = useState(null);
  const formdataref = useRef(null)
  const validateIfsc = async () => {
    let IFSC_CODE = document.getElementById('IFSC_CODE').value.toUpperCase();
    try {
      const response = await fetch(`https://ifsc.razorpay.com/${IFSC_CODE}`);
      if (response.ok) {
        setIsIfscValid(true);
      } else {
        setIsIfscValid(false);
      }
    } catch (error) {
      setIsIfscValid(false);
      console.error("Error validating IFSC code:", error);
    }
  };


  // const checkGSTandPAN = () => {
  //   try {
  //     let GST_No = document.getElementById('GST_No').value.toUpperCase();
  //     let PAN_No = document.getElementById('PAN_No').value.toUpperCase();

  //     const gstRegex = /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})$/;
  //     const panRegex = /^([A-Z]{5}[0-9]{4}[A-Z]{1})$/;

  //     const isGSTValid = gstRegex.test(GST_No);
  //     const isPANValid = panRegex.test(PAN_No);

  //     // const modifiedString = GST_No.slice(2, -3);

  //     setIsGSTValid(isGSTValid);
  //     setIsPANValid(isPANValid);

  //     if (!isGSTValid) {
  //       alert("Invalid GST Number");
  //     }
  //     if (!isPANValid) {
  //       alert("Invalid PAN Number");
  //     }

  //     // if (PAN_No === isPANValid) {
  //     //   setIsPANValid(isPANValid);
  //     // } else {
  //     //   alert('Invalid PAN Number');
  //     //   setIsPANValid(false);
  //     // }

  //     setIsGSTValid(isGSTValid);
  //   } catch (error) {
  //     console.error('Error in checkGSTandPAN:', error);
  //     throw error;
  //   }
  // };

  const checkGSTandPAN = (id, inputValue) => {

    const gstRegex = /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})$/;
    const panRegex = /^([A-Z]{5}[0-9]{4}[A-Z]{1})$/;

    let PAN_Number = document.getElementById('PAN_No')?.value.toUpperCase();
    let Gst_Number = document.getElementById('GST_No')?.value.toUpperCase();
    console.log("checkGSTandPAN called:", { id, inputValue, PAN_Number, Gst_Number });

    if (id === "PAN_No") {
      setIsPANValid(inputValue.trim() === "" ? null : panRegex.test(inputValue));
    }

    if (id === "GST_No") {

      if (!gstRegex.test(inputValue)) {
        return setIsGSTValid(false);
      }

      if (!PAN_Number || !panRegex.test(PAN_Number)) {
        return setIsGSTValid(false);
      }

      const panInGST = Gst_Number.slice(2, 12);

      if (panInGST !== PAN_Number) {
        return setIsGSTValid(false);
      }

      else {
        setIsGSTValid(true);
      }

    }

  };


  const isValidGSTUsingPAN = (gstNumber, panNumber) => {
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

    if (!gstRegex.test(gstNumber)) {
      return { valid: false, reason: "Invalid GST format" };
    }
    if (!panRegex.test(panNumber)) {
      return { valid: false, reason: "Invalid PAN format" };
    }
    const panInGST = gstNumber.slice(2, 12);
    if (panInGST !== panNumber) {
      return { valid: false, reason: "PAN does not match GST number" };
    }

    return { valid: true };
  };

  useEffect(() => {
    try {
      setpaymentdata(null)
      // getdata()
    } catch (error) {
      console.error('Error in useEffect:', error);
      throw error;
    }
  }, [])




  const setdata = (e) => {
    try {
      let check = document.getElementById("checkacnumber").value;
      let acnum = document.getElementById("Account_Number").value;
      if (check === "" || acnum === "") {
        setaccountnum(null);
      } else {
        setaccountnum(check === acnum ? true : false);
      }
      // setaccountnum(check === acnum && check !== "" && acnum !== "" ? true : false);

      const { id, value } = e.target;
      let finalValue = value;
      let errorMessage = "";
      const validUserName = /^[a-zA-Z0-9 ]*$/;
      const validPinCode = /^[0-9]{6}$/;
      const validMobile = /^[0-9]{10}$/;
      const validEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const validAccountNumber = /^[0-9]{6,18}$/;
      if ((id === "Bidder_CompanyName" || id === "Address" || id === "City" || id === "BANK_NAME" || id === "Account_HolderName" || id === "BranchName") && !validUserName.test(value)) {
        errorMessage = "Only alphanumeric characters and spaces are allowed.";
      }
      if (id === "PinCode") {
        if (value === "") {
          errorMessage = "";
        } else if (!validPinCode.test(value)) {
          errorMessage = "Pin code must be exactly 6 digits.";
        } else {
          errorMessage = "";
        }
      }
      // Ensure IFSC_CODE is always uppercase
      if (id === "IFSC_CODE") {
        finalValue = value.toUpperCase();
      }
      if (id === "MobileNumber" && !validMobile.test(value)) {
        errorMessage = "Mobile number must be exactly 10 digits.";
      }
      if (id === "Email") {
        if (value === "") {
          errorMessage = "";
        } else if (!validEmail.test(value)) {
          errorMessage = "Invalid email format. Example: abc@example.com.";
        } else {
          errorMessage = "";
        }
      }

      if (id === "checkacnumber" && !validAccountNumber.test(value)) {
        errorMessage = "Account number must be 6 to 18 digits.";
      }
      // Update form state
      SetForminf((prev) => ({ ...prev, [id]: finalValue }));
      setFormErrors((prev) => ({ ...prev, [id]: errorMessage }));
      // Perform validation only for GST_No and PAN_No
      if (id === "GST_No" || id === "PAN_No") {
        checkGSTandPAN(id, finalValue);
      }
    } catch (error) {
      console.error("Error in setdata:", error);
      throw error;
    }
  };



  const onSubmit = async (e) => {
    e.preventDefault()
    let token = localStorage.getItem("Token");
    try {
      const response = await fetch(`${apiurl}/VendorManagement/VendorRegistration`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          AuthToken: token
        },
        body: JSON.stringify(forminf),
      });
      const data = await response.json();
      console.log(data)
      if (data.message === "Vendor registered successfully") {
        alert(data.message)
        window.location.reload();
      }
      if (data.message === "Vendor already registered") {
        alert(data.message)
        window.location.reload();
      }
    } catch (error) {
      console.error('Error in onSubmit:', error);
      throw error;
    }
  }
  const resetData = () => {
    formdataref.current.reset()
    SetForminf([])
  }


  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '2.5rem', backgroundColor: '#ece9fe' }}>
        <h5 style={{ textAlign: "center" }}><b>Vendor Registeration Form</b></h5></div>
      <div style={{ backgroundColor: '#f4f7fe', backgroundSize: 'cover', width: '82vw', alignSelf: 'center', display: 'grid', justifyContent: "center", padding: '1rem', position: "relative", backdropFilter: 'blur(10px)', maxHeight: '91vh', overflowY: 'auto' }}>

        <div style={{ display: "grid", justifyContent: "center" }}>
          <div className="card-body my-3" style={{ width: "75vw" }}>
            <Form id='form1' ref={formdataref} onSubmit={(e) => { isPANValid === true && accountnum === true && isIfscValid === true ? onSubmit(e) : alert('incorrect details') }} style={{ backgroundColor: 'rgb(255,255,255,0.8)', borderRadius: '20px 20px 0px 0px' }} >

              <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
                <div style={{ backgroundColor: '#f4f7fe', borderRadius: '20px', paddingBottom: '15px' }}>
                  <div className="bidder_register_form">
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label>Company Name*:</label>
                      <input type="text" id="Bidder_CompanyName" placeholder="Enter your Company Name" className="form-control" required onChange={(e) => { setdata(e) }} /> {formErrors.Bidder_CompanyName && (
                        <small style={{ color: "red", fontWeight: "bold" }}>
                          {formErrors.Bidder_CompanyName}
                        </small>
                      )}
                    </div>
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label>Address*:</label>
                      <div style={{ position: 'relative' }}>
                        <input type="text" id="Address" placeholder="Enter Address" className="form-control" required onChange={(e) => { setdata(e) }} />
                        <img src={Location32} alt="Email Icon" style={{
                          position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", width: "20px",
                          height: "20px"
                        }} />
                      </div>
                      {formErrors.Address && (
                        <small style={{ color: "red", fontWeight: "bold" }}>
                          {formErrors.Address}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="bidder_register_form">
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label>City*:</label>
                      <input type="text" id="City" placeholder="Enter City" className="form-control" required onChange={(e) => { setdata(e) }} />
                      {formErrors.City && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.City}</small>)}
                    </div>
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label>Pin Code*:</label>
                      <input type="tel" id="PinCode" pattern="\d{6}" minLength="6" maxLength="6" placeholder="Enter Pin Code" className="form-control"
                        onInput={(e) => {
                          let enteredValue = e.target.value;
                          enteredValue = enteredValue.slice(0, 6).replace(/\D/g, '');
                          e.target.value = enteredValue;
                        }}
                        onChange={(e) => { setdata(e) }}
                        required
                      /> {formErrors.PinCode && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.PinCode}</small>)}
                    </div>
                  </div>
                  <div className="bidder_register_form">
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label>PAN Number (capital letters only)*:</label>
                      <input type="text" id="PAN_No" placeholder="Enter PAN No." className="form-control" required onChange={(e) => { setdata(e); }} style={{}} value={forminf.PAN_No || ""} minLength={10} maxLength={10} />
                      {isPANValid === false && <b style={{ color: "red" }}>Invalid PAN</b>}
                      {isPANValid === true && <b style={{ color: "green" }}>Valid</b>}
                    </div>

                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label>GST Number (capital letters only)*:</label>
                      <input type="text" id="GST_No" placeholder="Enter GST No." className="form-control" required onChange={(e) => { setdata(e); }} style={{}} value={forminf.GST_No || ""} minLength={15} maxLength={15} />
                      {isGSTValid === false && <b style={{ color: "red" }}>Incorrect GST</b>}
                      {isGSTValid === true && <b style={{ color: "green" }}>Correct</b>}
                    </div>

                  </div>
                  <div className="bidder_register_form">
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label>Mobile No*:</label>
                      <div style={{ position: "relative" }}>
                        <input type="text" className="form-control" id="Mobile_No" pattern="\d{10}" minLength="10" maxLength="10" placeholder="Enter Mobile No"
                          onInput={(e) => { let enteredValue = e.target.value; enteredValue = enteredValue.slice(0, 10).replace(/\D/g, ''); e.target.value = enteredValue; }} onChange={(e) => { setdata(e) }} required />
                        <img src={PhoneNumber32} alt="Email Icon" style={{
                          position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", width: "20px",
                          height: "20px"
                        }} />
                      </div>
                      {formErrors.MobileNumber && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.MobileNumber}</small>)}
                    </div>
                    <div className="mx-3 my-1" style={{ width: "29rem", position: "relative" }}>
                      <label>Email*:</label>
                      <div style={{ position: "relative" }}>
                        <input type="email" id="Email" placeholder="Enter Email" className="form-control pe-5" required onChange={(e) => setdata(e.target.value)} />
                        <img src={Email32} alt="Email Icon" style={{
                          position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", width: "20px",
                          height: "20px"
                        }} />
                      </div>
                      {formErrors.Email && (
                        <small style={{ color: "red", fontWeight: "bold" }}>
                          {formErrors.Email}
                        </small>
                      )}
                    </div>

                  </div>
                </div>
              </div>
              <div className="mx-5" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><img src={Bank32} /><h5 style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', margin: '0px' }}><b>Bank Details</b></h5></div>
              <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem 2rem 0px 2rem' }}>
                <div style={{ backgroundColor: '#f4f7fe', borderRadius: '20px', paddingBottom: '15px' }}>
                  <div className="bidder_register_form">
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label>Bank Name*:</label>
                      <input type="text" id="BANK_NAME" placeholder="Enter Bank Name" className="form-control" required onChange={(e) => { setdata(e) }} />
                      {formErrors.BANK_NAME && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.BANK_NAME}</small>)}
                    </div>
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label>Account Holder Name*:</label>
                      <input type="text" id="Account_HolderName" placeholder="Enter Account Holder Name" className="form-control" required onChange={(e) => { setdata(e) }} />
                      {formErrors.Account_HolderName && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.Account_HolderName}</small>)}
                    </div>
                  </div>
                  <div className="bidder_register_form">
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label>Account Number*:</label>
                      <input type="text" id='checkacnumber' placeholder="Enter Account Number" className="form-control" required onChange={(e) => { setdata(e) }} />
                      {formErrors.checkacnumber && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.checkacnumber}</small>)}
                    </div>
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label> Confirm Account Number*:</label>
                      <input type="text" id="Account_Number" placeholder="Confirm Account Number" className="form-control" required onChange={(e) => { setdata(e) }} />
                      {
                        accountnum !== null && (
                          <b style={{ color: accountnum === false ? 'red' : 'green' }}>{accountnum === false ? 'Account number does not match' : 'Matched'}</b>
                        )
                      }
                    </div>
                  </div>
                  <div className="bidder_register_form">
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label>IFSC Code*:</label>
                      <input type="text" id="IFSC_CODE" placeholder="Enter IFSC Code" className="form-control" required onChange={(e) => { setdata(e); validateIfsc() }} style={{ textTransform: 'uppercase' }} />
                      {
                        isIfscValid !== null && (
                          <b style={{ color: isIfscValid === false ? 'red' : 'green' }}>{isIfscValid === false ? 'IFSC Code is invalid' : 'IFSC code is valid'}</b>
                        )
                      }
                    </div>
                    <div className="mx-3 my-1" style={{ width: "29rem" }}>
                      <label>Branch Name*:</label>
                      <input type="text" id="BranchName" placeholder="Branch Name" className="form-control" required onChange={(e) => { setdata(e) }} />
                      {formErrors.BranchName && (<small style={{ color: "red", fontWeight: "bold" }}>{formErrors.BranchName}</small>)}
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', padding: '2.5rem' }}>
                <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', border: 'none', fontSize: '17px', gap: '4px' }}><img src={submit} style={{ width: '1.2rem', paddingBottom: '3px', fontSize: '15px' }} />Submit </button>
                <button onClick={resetData} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }}><img src={Cancel32} style={{ width: '1.2rem', }} /> Cancel</button>
                <Link to={'/Dashboard/DownloadReciept/' + forminf.Tender_ID + '/' + forminf.GST_No + '/' + forminf.PAN_No} hidden={recieptview} >Download Reciept</Link>
              </div>
            </Form>
          </div>
        </div>


      </div>
    </>
  );
};

export default VendorRegister;
